import GoogleFontPicker from './GoogleFontPicker';
export default GoogleFontPicker;
